export enum ReasonType {
  Unknown = 'Unknown',
  OrderCancellationByBackoffice = 'OrderCancellationByBackoffice',
  OrderCancellationByCustomer = 'OrderCancellationByCustomer',
}
